@if (!useMobileView) {
  <div class="sidebar pl-2" [@slideInOut]="isOpened ? 'in' : 'out'">
    <div class="flex h-full w-full flex-col gap-[1rem] overflow-hidden">
      <ng-container [ngTemplateOutlet]="panelHeader"></ng-container>
      <ng-container
        [ngTemplateOutlet]="panelContent"
        [ngTemplateOutletContext]="{
          contentClass: 'w-full flex-grow pl-[15px]',
        }"></ng-container>
    </div>
  </div>
}

@if (useMobileView) {
  <div
    class="fixed right-0 top-0 z-20 flex h-full w-full flex-col gap-[1rem] bg-white py-[0.5rem]"
    [@slideFixedInOut]="isOpened ? 'in' : 'out'">
    <ng-container [ngTemplateOutlet]="panelHeader"></ng-container>
    <ng-container
      [ngTemplateOutlet]="panelContent"
      [ngTemplateOutletContext]="{
        contentClass: 'flex-grow w-full px-4',
      }"></ng-container>
  </div>
}

<ng-template #panelHeader>
  <div class="z-20 flex w-full bg-white">
    <div class="flex cursor-pointer items-center" (click)="closePanel.emit()">
      <button mat-icon-button class="menu-close-btn mt-[2px] pr-3">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <div class="h3">{{ header | translate }}</div>
    </div>
  </div>
</ng-template>

<ng-template #panelContent let-contentClass="contentClass">
  <div
    [class]="contentClass"
    [ngClass]="{
      'overflow-y-auto': !hideContentOverflow,
      'overflow-y-hidden': hideContentOverflow,
    }">
    <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
  </div>
</ng-template>
